import { datadogRum } from '@datadog/browser-rum'

export const setDatadogUser = (userId, subscriptionId, email) => {
  datadogRum.setUserProperty('userId', userId)
  datadogRum.setUserProperty('subscriptionId', subscriptionId)
  datadogRum.setUserProperty('email', email)
}
